module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/aa27b71c7ae6f32740b23e783b11ef85.png";